import React from 'react';

export default class ToolbarComponent extends React.Component {
    render() {
        return (
            <div className="navbar">
                <div className="navbar-brand">
                    <div className="navbar-item">
                        <h1>Citas</h1>
                    </div>
                </div>
                <div className="navbar-menu is-active">
                    <div className="navbar-item">
                        <div className="tabs is-centered">
                            <ul>
                                <li className={this.props.chair == 0 ? "is-active" : ""}
                                    onClick={() => this.props.changeChair(0)}
                                >
                                    <a>Todo</a>
                                </li>
                                <li className={this.props.chair == 1 ? "is-active" : ""}
                                    onClick={() => this.props.changeChair(1)}
                                >
                                    <a>Silla 1</a>
                                </li>
                                <li className={this.props.chair == 2 ? "is-active" : ""}
                                    onClick={() => this.props.changeChair(2)}
                                >
                                    <a>Silla 2</a>
                                </li>
                                <li className={this.props.chair == 3 ? "is-active" : ""}
                                    onClick={() => this.props.changeChair(3)}
                                >
                                    <a>Silla 3</a>
                                </li>
                                <li className={this.props.chair == 4 ? "is-active" : ""}
                                    onClick={() => this.props.changeChair(4)}
                                >
                                    <a>Silla 4</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="navbar-item">
                        <div className="field has-addons">
                            <div className="control">
                                <input className="input" type="text"
                                    value={this.props.dateString}
                                    onFocus={this.props.openDatePicker}
                                    readOnly/>
                            </div>
                            <div className="control">
                                <a onClick={this.props.openDatePicker} className="button is-link">
                                    <i className="fas fa-calendar-alt"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="navbar-item">
                        <a onClick={() => this.props.changeDay("prev")}>
                            <i className="fas fa-arrow-left"></i>
                        </a>
                    </div>
                    <div className="navbar-item">
                        <a onClick={() => this.props.changeDay("next")}>
                            <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/home/scenes/pick-day/components/toolbar/index.js